import * as React from 'react';
import { useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Overview from './Overview';
import UsersOfStorage from './UsersOfStorage';

type Props = {
  storage: StorageType;
};
const Root: React.FC<Props> = ({ storage }) => {
  const theme = useTheme();

  return (
    <Grid size={{ xs: 12 }}>
      <Grid container size={{ xs: 12 }}>
        <Grid size={{ xs: 9 }} sx={{ borderRight: theme.palette.border }}>
          <Overview storage={storage} />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <UsersOfStorage storage={storage} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Root;
